<template>
    <v-select
        class="employee-multi-filter employee-checklist-select"
        :value="selectedKeys"
        :options="availableOptions"
        :reduce="option => option.key"
        :get-option-key="option => option.key"
        :selectable="option => !option.heading"
        :filter="filterOptions"
        placeholder="Навыки и должности"
        multiple
        :close-on-select="false"
        deselect-from-dropdown
        append-to-body
        :calculate-position="positionDropdown"
        @input="updateSelection"
    >
        <template #search="{attributes, events}">
            <input class="vs__search" v-bind="attributes" aria-label="Навыки и должности" v-on="events">
        </template>
        <template #selected-option-container="{option}">
            <span v-show="option.key === selectedKeys[0]" class="employee-multi-filter__summary" :title="selectionTitle">
                <span class="employee-multi-filter__closed-label">Навыки и должности:</span>
                <span class="employee-multi-filter__open-label">Выбрано:</span>
                {{ selectedKeys.length }}
            </span>
        </template>
        <template #option="option">
            <employee-filter-option :label="option.label" :heading="!!option.heading"
                                    :selected="selectedKeys.includes(option.key)" />
        </template>
        <template #no-options>Ничего не найдено</template>
    </v-select>
</template>

<script>
import {positionVueSelectDropdown} from '@/utils/vueSelectPositioning';
import {sourceSkillDescription} from '@/utils/employeeSkills';
import EmployeeFilterOption from './EmployeeFilterOption.vue';

export default {
    name: 'EmployeeMultiFilter',
    components: {EmployeeFilterOption},
    props: {
        itr: {type: Boolean, default: false},
        skills: {type: Array, default: () => []},
        positions: {type: Array, default: () => []},
        skillOptions: {type: Array, default: () => []},
        positionOptions: {type: Array, default: () => []},
        skillDescriptions: {type: Object, default: () => ({})}
    },
    computed: {
        availableOptions() {
            return [{key: 'category:itr', section: 'category', label: 'ИТР'}]
                .concat(this.groupOptions('skills', 'Навыки', this.skillOptions, this.skills))
                .concat(this.groupOptions('positions', 'Должности', this.positionOptions, this.positions));
        },
        selectedKeys() {
            return (this.itr ? ['category:itr'] : []).concat(this.skills.map(name => `skills:${name}`))
                .concat(this.positions.map(name => `positions:${name}`));
        },
        selectionTitle() {
            return this.availableOptions.filter(option => this.selectedKeys.includes(option.key))
                .map(option => option.label).join(', ');
        }
    },
    methods: {
        positionDropdown(dropdownList, component, position) {
            dropdownList.classList.add('employee-checklist-menu');
            return positionVueSelectDropdown(dropdownList, component, position);
        },
        groupOptions(section, label, options, selected) {
            const names = Array.from(new Set(options.concat(selected)))
                .sort((left, right) => left.localeCompare(right, 'ru'));
            if (!names.length) return [];
            return [{key: `heading:${section}`, section, label, heading: true}].concat(names.map(name => {
                const description = section === 'skills'
                    && (this.skillDescriptions[name] || sourceSkillDescription(name));
                return {key: `${section}:${name}`, section, name,
                    label: description ? `${name} — ${description}` : name};
            }));
        },
        filterOptions(options, search) {
            const query = String(search || '').trim().toLocaleLowerCase('ru-RU');
            const matches = options.filter(option => !option.heading
                && (option.section === 'category' || option.label.toLocaleLowerCase('ru-RU').includes(query)));
            const sections = new Set(matches.map(option => option.section));
            return options.filter(option => option.heading ? sections.has(option.section) : matches.includes(option));
        },
        updateSelection(keys) {
            const selected = new Set(keys || []);
            const options = this.availableOptions.filter(option => !option.heading && selected.has(option.key));
            this.$emit('update:itr', selected.has('category:itr'));
            this.$emit('update:skills', options.filter(option => option.section === 'skills').map(option => option.name));
            this.$emit('update:positions', options.filter(option => option.section === 'positions').map(option => option.name));
        }
    }
};
</script>

<style scoped>
.employee-multi-filter {
    --vs-font-size: 0.875rem;
    --vs-line-height: 1.5;
    width: 290px;
    max-width: 100%;
    min-width: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background: #fff;
}
.employee-multi-filter >>> .vs__dropdown-toggle {
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
    border-color: #ced4da;
    border-radius: 0.25rem;
}
.employee-multi-filter__summary {
    margin: 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    color: inherit;
    white-space: nowrap;
}
.employee-multi-filter__open-label,
.employee-multi-filter.vs--open .employee-multi-filter__closed-label {
    display: none;
}
.employee-multi-filter.vs--open .employee-multi-filter__open-label {
    display: inline;
}
.employee-multi-filter.vs--open .employee-multi-filter__summary {
    flex: 0 0 auto;
    margin-right: 8px;
}
.employee-multi-filter >>> .vs__selected-options {
    align-items: center;
    flex-wrap: nowrap;
    min-width: 0;
    padding: 0;
}
.employee-multi-filter >>> .vs__search,
.employee-multi-filter >>> .vs__search:focus {
    min-width: 25px;
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    color: inherit;
}
.employee-multi-filter >>> .vs__actions {
    padding: 0 0 0 6px;
}
</style>
